import { AS_BUSINESS_UNIT_TYPE } from '@/constants/businessUnit'

export const AS_USER_BUSINESS_UNIT_TYPE = AS_BUSINESS_UNIT_TYPE
